import React, { useMemo } from 'react'
import { Column } from 'react-table'

import { TableProps } from '../../../../Table'
import {
  dateColumn,
  orderNumberColumn,
  shipToAddresseeColumn,
  statusColumn,
  totalColumn,
  trackingColumn,
} from './columns'
import { StyledTable } from './StyledTable'
import { TableDataCustomerOrder } from './types'

const columnsForCustomerOrders = (urlFragment: string): Column<TableDataCustomerOrder>[] => [
  dateColumn(urlFragment),
  orderNumberColumn(urlFragment),
  shipToAddresseeColumn(urlFragment),
  totalColumn(urlFragment),
  statusColumn(urlFragment),
  trackingColumn(urlFragment),
]

export interface CustomerOrdersTableProps {
  className?: string
  urlFragment: string
  orders: TableDataCustomerOrder[]
}

export const CustomerOrdersTable: React.VFC<CustomerOrdersTableProps> = ({
  className,
  urlFragment,
  orders,
}) => {
  const columns = useMemo(() => columnsForCustomerOrders(urlFragment), [urlFragment])

  const initialSortBy = useMemo(
    () => [
      {
        desc: true,
        id: 'date',
      },
    ],
    [],
  )

  return orders.length ? (
    <StyledTable<React.FC<TableProps<TableDataCustomerOrder>>>
      className={className}
      columns={columns}
      data={orders}
      initialSortBy={initialSortBy}
      showHeaders
    />
  ) : null
}
